<template>
  <div class="layout" id="myComponentDiv">
    <div class="box-titulo">Reporte de Vehículos</div>
    <div class="box-container">
      <div class="box-filtres">
        <table width="100%">
          <tbody>
            <tr>
              <td class="pad10">
                <button
                  class="btn btn-info"
                  type="submit"
                  @click="openVehiculo(null)"
                >
                  Agregar
                </button>
              </td>
              <td class="pad10" width="1px">Placa</td>
              <td width="150px">
                <input
                  type="text"
                  class="form-control"
                  autocomplete="off"
                  v-model="placa"
                  style="text-transform: uppercase"
                  v-on:keypress="GLOBAL.SOLO_ALFANUMERICOS"
                  @keyup.enter="getReporteVehiculos"
                />
              </td>
              <td class="pad10" width="1px">Propietario</td>
              <td width="150px">
                <input
                  type="text"
                  class="form-control"
                  autocomplete="off"
                  v-model="propietario"
                  style="text-transform: uppercase"
                  v-on:keypress="GLOBAL.SOLO_ALFANUMERICOS"
                  @keyup.enter="getReporteVehiculos"
                />
              </td>
              <td width="1px" nowrap>
                <button
                  class="btn btn-warning"
                  type="submit"
                  @click="getReporteVehiculos"
                >
                  Consultar
                </button>
                <button
                  class="btn btn-secondary"
                  type="submit"
                  @click="borrarFiltros"
                >
                  Reset
                </button>
              </td>
              <td width="40px">
                <div v-if="loading">
                  <img src="dist/img/kubber-loading.gif" style="width: 30px" />
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div>
        <table
          id="vehiculostable"
          width="100%"
          class="display nowrap"
          style="width: 100%"
        >
          <thead>
            <tr>
              <th width="100px">Placa</th>
              <th width="100px">Estado</th>
              <th width="100px">Codigo</th>
              <th width="100px">Propietario</th>
              <th width="100px">Vin</th>
              <th width="100px">Fecha Certificación</th>
              <th width="100px">Proxima Revisión</th>
              <th width="100px">Acciones</th>
            </tr>
          </thead>
        </table>
      </div>

      <div id="myModal" class="modal" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div :class="['modal-header', GLOBAL.COLOR_PERFIL[GLOBAL.PERFIL]]">
              <h5 class="modal-title">Vehiculos</h5>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="pad10 bg-formulario">
                <div class="propiedades-json">
                  <table width="100%">
                    <tbody>
                      <tr>
                        <th colspan="2" class="factura-label">
                          DATOS DEL VEHICULO
                        </th>
                      </tr>
                      <tr>
                        <td width="100px">PLACA:</td>
                        <td>
                          <input
                            type="text"
                            class="form-control"
                            v-model="vehiculo.placa"
                            style="text-transform: uppercase"
                            v-on:keypress="GLOBAL.SOLO_ALFANUMERICOS"
                            autocomplete="off"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>VIN:</td>
                        <td>
                          <input
                            type="text"
                            class="form-control"
                            v-model="vehiculo.vin"
                            style="text-transform: uppercase"
                            v-on:keypress="GLOBAL.SOLO_ALFANUMERICOS"
                            autocomplete="off"
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div class="propiedades-json">
                  <table width="100%">
                    <tbody>
                      <tr>
                        <th class="factura-label">PROPIETARIO</th>
                      </tr>
                      <tr>
                        <td>
                          <div>Nro. Identificación / RFC</div>
                          <input
                            type="text"
                            class="form-control"
                            style="text-transform: uppercase"
                            v-model="vehiculo.atributos.propietario_codigo"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <div>Nombre Completo O Razón social</div>
                          <input
                            type="text"
                            class="form-control"
                            style="text-transform: uppercase"
                            v-model="vehiculo.atributos.propietario_nombre"
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div class="propiedades-json">
                  <table width="100%">
                    <tbody>
                      <tr>
                        <th colspan="4" class="factura-label">
                          OTROS DETALLES
                        </th>
                      </tr>
                      <tr>
                        <td colspan="4">
                          <div>Marca y Linea</div>
                          <input
                            type="text"
                            class="form-control"
                            style="text-transform: uppercase"
                            v-model="vehiculo.atributos.marca"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>Modelo:</td>
                        <td>
                          <input
                            type="text"
                            v-model="vehiculo.atributos.modelo"
                            class="form-control"
                            v-on:keypress="GLOBAL.SOLO_NUMEROS"
                          />
                        </td>
                        <td>Cilindros:</td>
                        <td>
                          <input
                            type="text"
                            v-model="vehiculo.atributos.linea"
                            class="form-control"
                            v-on:keypress="GLOBAL.SOLO_NUMEROS"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>Litros:</td>
                        <td>
                          <input
                            type="text"
                            v-model="vehiculo.atributos.litros"
                            class="form-control"
                            v-on:keypress="GLOBAL.SOLO_NUMEROS"
                          />
                        </td>
                        <td>Servicio:</td>
                        <td>
                          <select
                            v-model="vehiculo.atributos.tipo_servicio"
                            class="form-control"
                          >
                            <option selected disabled></option>
                            <option value="publico">PUBLICO</option>
                            <option value="privado">PRIVADO</option>
                          </select>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div class="propiedades-json">
                  <table width="100%">
                    <tbody>
                      <tr>
                        <th colspan="2" class="factura-label">
                          FECHA MANTENIMIENTO Y PROXIMA REVISIÓN
                        </th>
                      </tr>
                      <tr>
                        <td width="50%">FECHA CERTIFICACIÓN:</td>
                        <td>
                          <input
                            class="form-control center"
                            type="text"
                            datatype="fecha"
                            autocomplete="off"
                            id="fecha_mantenimiento"
                            readonly="true"
                            @change="sumarUnAno"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>PRÓXIMA REVISIÓN:</td>
                        <td>
                          <input
                            class="form-control center"
                            type="text"
                            datatype="fecha"
                            autocomplete="off"
                            id="fecha_revision"
                            readonly="true"
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div>
                  <table width="100%">
                    <tbody>
                      <tr>
                        <td colspan="3">
                          <div
                            style="
                              min-height: 30px;
                              color: red;
                              text-align: center;
                            "
                          >
                            {{ mensaje }}
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td class="left">
                          <button
                            class="btn btn-secondary"
                            data-dismiss="modal"
                            aria-label="Close"
                          >
                            Cerrar
                          </button>
                        </td>
                        <td>
                          <div v-if="proceso_guardado">
                            <img
                              src="dist/img/kubber-loading.gif"
                              style="width: 30px"
                            />
                            Generado proceso, espere...
                          </div>
                        </td>
                        <td class="right">
                          <button
                            class="btn btn-primary"
                            v-if="this.vehiculo._id == 0"
                            @click="guardarVehiculo"
                          >
                            Crear Vehículo
                          </button>
                          <button
                            class="btn btn-success"
                            v-else
                            @click="guardarVehiculo"
                          >
                            Actualizar Vehículo
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div id="myIbuttons" class="modal" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div :class="['modal-header', GLOBAL.COLOR_PERFIL[GLOBAL.PERFIL]]">
              <h5 class="modal-title">PLACA: {{ vehiculo.placa }}</h5>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body pad10">
              <table width="100%">
                <tbody>
                  <tr>
                    <td colspan="2">Código de Ibutton:</td>
                  </tr>
                  <tr>
                    <td>
                      <input
                        class="form-control"
                        v-model="identificadorIbutton"
                        :disabled="procesando_identificador"
                      />
                    </td>
                    <td width="1px">
                      <button
                        class="btn btn-info"
                        v-on:click="vincularIbutton"
                        :disabled="procesando_identificador"
                      >
                        <i class="fa-solid fa-plus"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div
                style="min-height: 30px; text-align: center; font-weight: bold"
              >
                <div v-if="procesando_identificador">
                  PROCESANDO...
                  <img src="dist/img/kubber-loading.gif" style="width: 30px" />
                </div>
                <div v-if="mensaje_identificador">
                  {{ mensaje_identificador }}
                </div>
              </div>
              <br />
              <table class="table table-striped" width="100%">
                <tbody>
                  <tr>
                    <th colspan="3">Ibuttons asociados</th>
                  </tr>
                  <tr v-for="(item, index) in listaIbutton" :key="item">
                    <td class="mono">{{ item.codigo }}</td>
                    <td>
                      {{ index === 0 ? "ACTIVO" : "INACTIVO" }}
                    </td>
                    <td
                      v-on:click="desvincularIbutton(item.codigo)"
                      width="1px"
                    >
                      <button class="btn btn-sm btn-danger">
                        <i class="fa-solid fa-close"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <div v-if="!permiso_lista">
        {{ this.person.nombre }}, {{ this.GLOBAL.MENSAJE.SIN_AUTORIZACION }}
      </div>
    </div>
  </div>
</template>

<script>
import GLOBAL from "../../Global.js";
import VehiculoService from "./VehiculoService.js";

export default {
  data() {
    return {
      GLOBAL,
      table: null,
      reporteService: null,
      person: null,
      permiso_lista: false,
      reporte: [],
      loading: true,
      datatable: null,
      placa: "",
      propietario: "",
      vehiculo: {},
      mensaje: "",
      proceso_guardado: false,
      listaIbutton: [],
      identificadorIbutton: "",
      procesando_identificador: false,
      mensaje_identificador: "Se requiere minimo 16 caracteres",
    };
  },
  components: {},
  created() {
    this.resetDatosVehiculos();

    this.person = JSON.parse(sessionStorage.getItem(GLOBAL.SESSION_KEY));
    this.permiso_lista = this.person.funciones.includes(
      GLOBAL.PERMISOS.REPORTE.HOROMETRO
    );
    this.reporteService = new VehiculoService();

    try {
      this.datatable = null;
      $("#vehiculostable").DataTable().destroy();
    } catch (error) {}
  },
  beforeRouteLeave(to, from, next) {
    $("#vehiculostable").DataTable().destroy();
    next();
  },
  mounted() {
    $("input[datatype='fecha']").datepicker();

    var vm = this;

    try {
      this.datatable = null;
      $("#vehiculostable").DataTable().destroy();
    } catch (error) {}

    this.datatable = $("#vehiculostable").DataTable({
      processing: true,
      serverSide: true,
      searching: false,
      ajax: {
        url: GLOBAL.API_VEHICULOS_LISTA,
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: "Basic " + vm.person.token,
          Environment: vm.person.empresas,
        },
        data: function (data) {
          data.placa = vm.placa;
          data.propietario = vm.propietario;
        },
        beforeSend: function () {
          vm.loading = true;
        },
        complete: function () {
          vm.loading = false;
        },
      },
      createdRow: function (row, data) {
        var deleteBtn = $(
          "<button class='btn btn-sm btn-info'><i class='fa-solid fa-receipt'></i></button> "
        );
        $(deleteBtn).on("click", function () {
          vm.openVehiculo(data);
        });
        $("td", row).eq(7).append(deleteBtn);

        var infoBtn = $(
          "<button class='btn btn-sm btn-warning'><i class='fa-solid fa-hockey-puck'></i></button>"
        );
        $(infoBtn).on("click", function () {
          vm.openIbuttons(data);
        });
        $("td", row).eq(7).append(infoBtn);
      },
      columns: [
        { data: "placa" },
        {
          data: "estado",
          render: function (data, type, row) {
            return row.estado == "A" ? "ACTIVO" : "INACTIVO";
          },
        },
        {
          render: function (data, type, row) {
            return row.atributos.propietario_codigo;
          },
        },
        {
          render: function (data, type, row) {
            return row.atributos.propietario_nombre;
          },
        },
        { data: "vin" },
        {
          render: function (data, type, row) {
            return row.fecha_mantenimiento != null
              ? row.fecha_mantenimiento.split("T")[0]
              : "";
          },
        },
        {
          render: function (data, type, row) {
            return row.fecha_revision != null
              ? row.fecha_revision.split("T")[0]
              : "";
          },
        },
        {
          render: function (data, type, row) {
            return "";
          },
        },
      ],
      dom:
        "<'btt row'<'col-sm-2'l><'col-sm-4'B><'col-sm-6'f>>" +
        "<'row'<'col-sm-12'tr>>" +
        "<'btt row'<'col-sm-5'i><'col-sm-7'p>>",
      buttons: [
        {
          extend: "copyHtml5",
          text: '<i class="fa-regular fa-clipboard"></i>',
        },
        {
          extend: "excelHtml5",
          text: '<i class="fa-regular fa-file-excel"></i>',
        },
        {
          extend: "csvHtml5",
          text: '<i class="fa-solid fa-file-csv"></i>',
        },
        {
          extend: "pdfHtml5",
          text: '<i class="fa-regular fa-file-pdf"></i>',
        },
      ],
      scrollX: true,
      responsive: false,
      autoWidth: true,
      language: {
        url: "plugins/Spanish.json",
      },
    });
  },
  methods: {
    sumarUnAno() {
      const fechaActual = new Date(this.vehiculo.fecha_mantenimiento);
      fechaActual.setFullYear(fechaActual.getFullYear() + 1);
      this.vehiculo.fecha_revision = fechaActual.toISOString().split("T")[0]; // Formatear la fecha en ISO
    },

    borrarFiltros() {
      this.placa = "";
      this.propietario = "";
      this.datatable.ajax.reload();
    },

    resetDatosVehiculos() {
      this.vehiculo = {};
      this.vehiculo._id = 0;
      this.vehiculo.placa = "";
      this.vehiculo.vin = "";
      this.vehiculo.atributos = {};
      this.vehiculo.atributos.propietario_codigo = "";
      this.vehiculo.atributos.propietario_nombre = "";
      this.vehiculo.atributos.marca = "";
      this.vehiculo.atributos.modelo = "";
      this.vehiculo.atributos.potencia = "";
      this.vehiculo.atributos.servicio = "";
      this.vehiculo.fecha_revision = "";
      this.vehiculo.fecha_mantenimiento = "";
    },

    getReporteVehiculos() {
      this.datatable.ajax.reload();
    },

    openVehiculo(item) {
      $("#fecha_revision").val("");
      $("#fecha_mantenimiento").val("");
      console.log(item);
      if (item == null) {
        this.resetDatosVehiculos();
      } else {
        this.vehiculo = item;
        try {
          $("#fecha_revision").val(this.vehiculo.fecha_revision.split("T")[0]);
        } catch (error) {}
        try {
          $("#fecha_mantenimiento").val(
            this.vehiculo.fecha_mantenimiento.split("T")[0]
          );
        } catch (error) {}
      }
      this.mensaje = "";
      $("#myModal").modal("show");
    },

    openIbuttons(item) {
      console.log(item);
      if (item == null) {
        this.resetDatosVehiculos();
      } else {
        this.vehiculo = item;
      }
      this.mensaje = "";
      this.getIdentificadoresPorVehiculo();
    },

    guardarVehiculo() {
      var validacion = "OK";

      this.vehiculo.placa = this.vehiculo.placa.trim().toUpperCase();

      this.vehiculo.atributos.propietario_codigo =
        this.vehiculo.atributos.propietario_codigo + "";
      this.vehiculo.atributos.propietario_codigo =
        this.vehiculo.atributos.propietario_codigo.trim().toUpperCase();
      this.vehiculo.atributos.propietario_nombre =
        this.vehiculo.atributos.propietario_nombre.trim().toUpperCase();

      this.vehiculo.fecha_revision = $("#fecha_revision").val().split("T")[0];
      this.vehiculo.fecha_mantenimiento = $("#fecha_mantenimiento")
        .val()
        .split("T")[0];

      if (this.vehiculo.fecha_revision == "") {
        validacion = "Debe seleccionar una fecha de revisión";
      }

      if (this.vehiculo.fecha_mantenimiento == "") {
        validacion = "Debe seleccionar una fecha de mantenimiento";
      }

      if (this.vehiculo.placa == "") {
        validacion = "La placa no debe ser vacia";
      }

      if (validacion == "OK") {
        this.mensaje = "";
        this.proceso_guardado = true;

        var request = { ...this.vehiculo };

        if (this.vehiculo._id != 0) {
          this.reporteService
            .actualizarVehiculo(this.person, request)
            .then((data) => {
              console.log(data);
              if (data.status == 200) {
                $("#myModal").modal("hide");
                this.getReporteVehiculos();
              } else if (data.status == 409) {
                this.mensaje = data.data;
              } else {
                this.mensaje = "No fué posible realizar la operación";
              }
              this.proceso_guardado = false;
            });
        } else {
          this.reporteService
            .crearVehiculo(this.person, request)
            .then((data) => {
              console.log(data);
              if (data.status == 200) {
                $("#myModal").modal("hide");
                this.getReporteVehiculos();
              } else if (data.status == 409) {
                this.mensaje = data.data;
              } else {
                this.mensaje = "No fué posible realizar la operación";
              }
              this.proceso_guardado = false;
            });
        }
      } else {
        this.mensaje = validacion;
      }
    },

    getIdentificadoresPorVehiculo() {
      if (this.vehiculo != null) {
        this.procesando_identificador = true;
        this.reporteService
          .getIdentificadoresPorVehiculo(this.person, this.vehiculo.uniqueid)
          .then((data) => {
            console.log(data);
            this.listaIbutton = data;
            this.procesando_identificador = false;
            $("#myIbuttons").modal("show");
          })
          .then(() => {
            this.loading = false;
          });
      }
    },

    vincularIbutton() {
      if (
        this.identificadorIbutton !== null &&
        this.identificadorIbutton.length === 16
      ) {
        this.mensaje_identificador = "";
        var request = {
          vehiculo_uniqueid: this.vehiculo.uniqueid,
          codigo: this.identificadorIbutton,
        };
        this.procesando_identificador = true;
        this.reporteService
          .vincularIdentificador(this.person, request)
          .then((data) => {
            console.log(data);
            this.identificadorIbutton = "";
            this.procesando_identificador = false;
            this.getIdentificadoresPorVehiculo();
          })
          .catch((error) => {
            console.error(error);
            this.loading = false;
            this.mensaje_identificador =
              "Ha ocurrido un error, comuníquese con soporte";
          });
      } else {
        this.mensaje_identificador =
          "No cumple con la cantidad esperada, deben ser 16 caracteres.";
      }
    },

    desvincularIbutton(codigo) {
      const confirmacion = confirm("¿Desea desvincular el iButton?");

      if (confirmacion) {
        var request = {};
        request = {
          vehiculo_uniqueid: this.vehiculo.uniqueid,
          codigo: codigo,
        };
        this.procesando_identificador = true;
        this.reporteService
          .desvincularIdentificador(this.person, request)
          .then((data) => {
            console.log(data);
            this.procesando_identificador = false;
            this.getIdentificadoresPorVehiculo();
            $("#myIbuttons").modal("show");
          })
          .then(() => {
            this.loading = false;
          });
      }
    },
  },
};
</script>
